import { useState } from 'react';
import type { TipoCasas } from '@triade/contracts';
import { formatarTextoDigitado } from '@/lib/format';

/**
 * Campo numerico que aceita a precisao do banco (ate 6 casas em dinheiro, 8 em taxa) e FORMATA ao sair do campo: fora de foco
 * o texto aparece nas casas da empresa (HALF_UP); com foco volta o texto digitado, inteiro. O valor guardado e enviado e sempre o
 * digitado: a formatacao e so o que se ve (como o formato de celula do Excel).
 */
export function useFormatoNoBlur(valor: string, tipo: TipoCasas): {
  value: string;
  onFocus: () => void;
  onBlur: () => void;
} {
  const [foco, setFoco] = useState(false);
  return {
    value: foco ? valor : formatarTextoDigitado(valor, tipo),
    onFocus: () => setFoco(true),
    onBlur: () => setFoco(false),
  };
}
